// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3RVdh","footer":"ModalUpdate_footer__23SI6"};